import React, { PureComponent } from 'react';
import { Loader } from 'react-loaders';
import orderBy from 'lodash/orderBy';

import { batchRequest } from '../../../../api/ApiService';
import Auth from '../../../../routes/Auth';
import { isSurveyFinished } from '../../../../api/Surveys';

import {
  Wrapper,
  PreTitle,
  Title,
  Text,
  ContentContainer
} from '../../components/ui';

import SkillsChart from '../../components/skills-chart';

class FeedbackStep2 extends PureComponent {
  constructor(props) {
    super(props);

    this.state = {
      loaded: false,
      chartData: [],
      showData: {
        second: false,
        final: false
      }
    };
  }

  componentDidMount() {
    const { surveys } = this.props;
    const receiverId = Auth.getUserId();

    let finishedSurveys =
      surveys && surveys.length > 0
        ? surveys.filter(i => isSurveyFinished(i))
        : [];

    const requestUrls = finishedSurveys.map(i => `${process.env.REACT_APP_API_URL}v2/forms/score/${receiverId}/${i.id}/`);

    batchRequest(
      requestUrls
    ).then(res => {
      let chartData = [];
      let showData = {
        second: false,
        final: false
      };

      res.forEach((scoreValueResult, index) => {
        const currentSurvey = finishedSurveys[index];

        if (currentSurvey.stage === 'initial') {
          chartData = scoreValueResult.body && scoreValueResult.body.user_score_question ? scoreValueResult.body.user_score_question.map(userScoreQuestion => {
            const chartItem = {
              question: userScoreQuestion.question,
              initial: userScoreQuestion.median
            };

            return chartItem;
          }) : [];
        } else if (scoreValueResult.body && scoreValueResult.body.user_score_question) {
          scoreValueResult.body.user_score_question.forEach(userScoreQuestion => {
            const currentQuestion = chartData.find(chartItem => chartItem.question === userScoreQuestion.question);
            if (currentQuestion) {
              chartData.find(chartItem => chartItem.question === userScoreQuestion.question)[currentSurvey.stage] = userScoreQuestion.median;
            } else {
              chartData.push({
                question: userScoreQuestion.question,
                [currentSurvey.stage]: userScoreQuestion.median
              });
            }

            showData[currentSurvey.stage] = true;
          });
        }
      });

      const chartOrder = {
        'Work Ethics': 1,
        'Conflict Management': 2,
        'Supportive': 3,
        'Communication': 4,
        'Analytical': 5,
      };
      chartData = chartData.map(i => ({
        ...i,
        order: i.question in chartOrder ? chartOrder[i.question] : 100,
      }));
      chartData = orderBy(chartData, 'order', ['asc']);

      this.setState({
        loaded: true,
        chartData,
        showData
      });
    })
      .catch(err => { console.log(err); });
  }

  render() {
    const {
      loaded,
      chartData,
      showData
    } = this.state;

    return loaded ? (
      <Wrapper>
        <PreTitle>Feedback</PreTitle>
        <Title>Teamwork Skills That You Are Demonstrating</Title>
        <Text>
          <p>The Skills Map below is a visual indicator of your performance. The wider the filled area, on a specific skill, the greater your performance in demonstrating that skill.</p>
        </Text>
        <ContentContainer>
          <SkillsChart
            title='Skills Map'
            data={chartData}
            showData={showData}
          />
        </ContentContainer>
        <Text>
          <p>Let’s explore each, starting with Work Ethics.</p>
        </Text>
      </Wrapper>
    ) : <Loader type="ball-scale-ripple" active />;
  }

}

export default FeedbackStep2;



// WEBPACK FOOTER //
// ./src/components/peer-feedback/pages/feedback/step2.js